
export const buildTimestampedFileName = (baseName) => {
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Chicago",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }).formatToParts(new Date());

    const valueByType = parts.reduce((acc, part) => {
        if (part.type !== "literal") {
            acc[part.type] = part.value;
        }
        return acc;
    }, {});

    // Use the dynamic filename instead of hardcoding 
    return `${baseName}_${valueByType.year}${valueByType.month}${valueByType.day}_${valueByType.hour}${valueByType.minute}${valueByType.second}`;
};